import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKixieRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M23.8 8.6H8v15.3h15.8z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#F10606",
		d: "M20.3 4h-8.6A7.7 7.7 0 0 0 4 11.7V28h16.3c4.3 0 7.7-3.4 7.7-7.7v-8.6C28 7.4 24.6 4 20.3 4m.1 19h-3.8l-1.5-5.1h-1.5l-1 5H9L11.6 9h3.6L14 14.8h1.3L19.2 9H23l-4.6 7z"
	})]
});
export default SvgKixieRegularIcon;
